/**
 * @generated SignedSource<<7807a89c68ac9a44db6c3316858f4987>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type team_issueFieldTeamInlineEditFull_TeamInlineEditViewWithIsEditable_fragmentRef$data = {
  readonly fieldId: string;
  readonly id: string;
  readonly name: string;
  readonly selectedTeam: {
    readonly jiraSuppliedId: string;
    readonly jiraSuppliedName: string | null | undefined;
  } | null | undefined;
  readonly type: string;
  readonly " $fragmentSpreads": FragmentRefs<"team_issueFieldTeamReadviewFull_TeamReadView">;
  readonly " $fragmentType": "team_issueFieldTeamInlineEditFull_TeamInlineEditViewWithIsEditable_fragmentRef";
};
export type team_issueFieldTeamInlineEditFull_TeamInlineEditViewWithIsEditable_fragmentRef$key = {
  readonly " $data"?: team_issueFieldTeamInlineEditFull_TeamInlineEditViewWithIsEditable_fragmentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"team_issueFieldTeamInlineEditFull_TeamInlineEditViewWithIsEditable_fragmentRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "team_issueFieldTeamInlineEditFull_TeamInlineEditViewWithIsEditable_fragmentRef",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "FragmentSpread",
      "name": "team_issueFieldTeamReadviewFull_TeamReadView"
    },
    {
      "concreteType": "JiraTeamView",
      "kind": "LinkedField",
      "name": "selectedTeam",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "jiraSuppliedId"
        },
        {
          "kind": "ScalarField",
          "name": "jiraSuppliedName"
        }
      ]
    }
  ],
  "type": "JiraTeamViewField"
};

(node as any).hash = "b9fb955ce9530b3f35116dcc41a56241";

export default node;
